//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var BASE_URL = "/prototype/accounting/accounts-payable/payments";
import { createExport } from '@/mixins/createExport';

export default {
    mixins: [createExport],
    data: function data() {
        return {
            startDate: moment().format("MM/DD/YYYY"),
            endDate: moment().format("MM/DD/YYYY")
        };
    },
    created: function created() {
        var $el = this;
        Event.$on('export-payment', function () {
            return $el.$children[0].$data.showSmallModal = true;
        });
    },
    beforeDestroy: function beforeDestroy() {
        Event.$off('export-payment');
    },

    methods: {
        process: function process() {
            this.loading = true;

            var data = {
                startDate: this.startDate,
                endDate: this.endDate
            };

            this.createExport(data, BASE_URL + "/export", 'avid-export', '.csv');

            this.loading = false;
        },
        close: function close() {
            Event.$emit('close-small-modal');
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/accounting/accounts-payable/payments/ExportPayment.vue
// module id = 7SRp
// module chunks = 0 1